<template>
  <div class="text-fill" :class="{'base-input-width':!nested}">
    <!--    <el-input-->
    <!--      :placeholder="placeholder"-->
    <!--      ref="textarea"-->
    <!--      v-model="issue.value"-->
    <!--      :type="issue.rows > 1 ? 'textarea' : inputType"-->
    <!--      :rows="issue.rows"-->
    <!--      resize="none"-->
    <!--      @change="$emit('change')"-->
    <!--    >-->
    <!--      <template v-slot:append v-if="issue.messageValidate">-->
    <!--        <el-button v-if="!issue.isValidateCode" type="primary" @click="openDialog">-->
    <!--          <template v-if="countDown > 0">-->
    <!--            <span>{{ countDown }}秒后重试</span>-->
    <!--          </template>-->
    <!--          <template v-else>-->
    <!--            <span>发送验证码</span>-->
    <!--          </template>-->
    <!--        </el-button>-->
    <!--        <template v-else>-->
    <!--          <el-button disabled type="primary">已验证</el-button>-->
    <!--        </template>-->
    <!--      </template>-->
    <!--    </el-input>-->
    <relation-input
      ref="input"
      :placeholder="placeholder"
      v-model="issue.value"
      :type="issue.rows > 1 ? 'textarea' : inputType"
      :rows="issue.rows"
      resize="none"
      @change="$emit('change')"
      :enable-relation="issue.setting.enableRelation"
      :question-id="question.id"
      :question-type="question.questionType"
      :prefix-icon="prefixIcon ? ('iconfont ' + prefixIcon) : ''"
      :disable-copy="issue.disableCopy"
      :readonly="view || issue.readonly"
      :min-length="issue.min_length"
      :max-length="issue.max_length"
      :validate="issue.validate"
      :enabled-error-tip="enabledErrorTip"
      :allow-error-list="issue.allowErrorList"
    >
      <template v-slot:append v-if="issue.messageValidate">
        <el-button v-if="!issue.isValidateCode" type="primary" @click="openDialog">
          <template v-if="countDown > 0">
            <span>{{ countDown }}秒后重试</span>
          </template>
          <template v-else>
            <span>发送验证码</span>
          </template>
        </el-button>
        <template v-else>
          <el-button disabled type="primary">已验证</el-button>
        </template>
      </template>
    </relation-input>
    <template v-if="issue.messageValidate">
      <template v-if="!issue.isValidateCode">
        <el-input class="mt-2" v-if="msgFlag" placeholder="请输入验证码" v-model="msgCode">
          <template v-slot:append>
            <el-button type="primary" @click="onValidate">
              <span>验证</span>
            </el-button>
          </template>
        </el-input>
      </template>
      <template v-else>
        <span>当前手机号已验证，更换手机号</span>
        <span class="text-theme" @click="sendAgain">重新验证</span>
      </template>
    </template>
    <template v-if="questionErrorText">
      <div class="text-danger mt-1">
        <span>{{questionErrorText}}</span>
      </div>
    </template>
    <el-dialog :visible.sync="codePopup" width="700px" title="获取验证码">
      <div class="mb-5" v-if="codePopup">
        <code-input ref="codeInput" :src="imgCodeUrl" @refresh="onRefresh" @finished="onFinished" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getImgCode, sendSmsCode, validateCode, ValidateType,getInputPrefixIcon } from 'dygc'
import { Message, MessageBox } from 'dygc-ui'
import CodeInput from '@/questions/components/CodeInput'
import RelationInput from '@/questions/components/RelationInput'

const SUCCESS = 0 // 成功
const REPEAT_SEND = 1 //当前答案已经验证过此手机号
const ERROR = 2 // 失败 短信数量为0或基础模块出错
export default {
  name: 'TextFill',
  components: { RelationInput, CodeInput },
  changeExpr: 'issue.value',
  data() {
    return {
      randomStr: Date.now(),
      codePopup: false,
      countDown: 0,
      msgCode: '',
      msgFlag: false
    }
  },
  computed: {
    enabledErrorTip(){
      if(this.issue.validate !== ValidateType.NUM) return true
      return this.issue.outOfRange !== 1
    },
    questionErrorText(){
      if(!this.question.questionErrorList) return ''
      return this.question.questionErrorList.find(err => err.key === this.question.id)?.message
    },
    showErrorTip(){
      return !!this.errorTip.length
    },
    errorTip(){
      return this.issue.getErrorTip()
    },
    imgCodeUrl() {
      return getImgCode(this.issue.value.trim(), this.randomStr)
    },
    inputType() {
      const type = this.issue.inputType
      return type === 'password' ? type : 'text'
    },
    prefixIcon() {
      return getInputPrefixIcon(this.question.issue.validate)
    },
    placeholder() {
      return this.issue.placeholder || '请输入'
    }
  },
  methods: {
    onRefresh() {
      this.randomStr = Date.now()
    },
    onFinished(val) {
      console.log(val)
      this.imgCode = val
      this.sendSmsCode()
    },
    repeatPhone() {
      this.question.issue.isValidateCode = true
      this.oldPhone = ''
    },
    sendSmsCode() {
      if (!this.imgCode) {
        return
      }
      if (this.__disabled) return
      let answerId = this.$bus.answerId
      let surveyId = this.$bus.survey.id
      let phone = this.issue.value
      let unique = this.issue.data_unique
      let questionId = this.question.id
      if (this.oldPhone === phone) {
        this.repeatPhone()
        this.codePopup = false
        return
      }
      this.__disabled = true
      sendSmsCode({
        answerId,
        surveyId,
        phone,
        unique,
        questionId,
        preCode: this.imgCode
      })
        .then(res => {
          let data = res.data
          if (data === SUCCESS) {
            this.countDown = 60
            this.openCountDown()
            this.msgFlag = true
            this.codePopup = false
          } else if (data === REPEAT_SEND) {
            this.repeatPhone()
            this.codePopup = false
          } else if (data === ERROR) {
            this.codePopup = false
            if (res.msg === '答题确认短信余额不足') {
              this.issue.messageValidate = false
              return
            } else {
              this.$refs.codeInput.clear()
              this.$nextTick(() => {
                Message({
                  message: res.msg,
                  type: 'warning'
                })
              })
            }
            this.imgCode = ''
          } else {
            if (res.msg === '短信发送失败，同一手机号每天最多发送5次') {
              // this.question.issue.messageValidate = false
              this.codePopup = false
            }
            if (res.code === 1) {
              Message({
                message: res.msg,
                type: 'warning'
              })
              this.codePopup = false
            }
          }
          this.$nextTick(() => {
            this.__disabled = false
          })
        })
        .catch(err => {})
    },
    onValidate() {
      // let rootVm = this.rootVm
      let answerId = this.$bus.answerId
      let surveyId = this.$bus.survey.id
      let issue = this.issue
      let code = this.msgCode.trim()
      let phone = issue.value.trim()

      if (!code) {
        Message({
          message: '请输入验证码',
          type: 'warning'
        })
        return
      }
      if (this.validate) return
      this.validate = true
      validateCode({
        phone,
        answerId,
        surveyId,
        code,
        preCode: this.imgCode
      })
        .then(res => {
          let { code } = res
          if (code === 0) {
            issue.isValidateCode = true
          } else if (code === 1) {
            Message({
              message: res.msg,
              type: 'warning'
            })
          } else {
          }
          this.validate = false
        })
        .catch(err => {
          this.validate = false
        })
    },
    openCountDown() {
      this.countDownTimer = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          this.clearCountDown()
        }
      }, 1000)
    },
    clearCountDown() {
      clearInterval(this.countDownTimer)
      this.countDownTimer = null
      this.countDown = 0
    },
    openDialog() {
      console.log('xxx')
      try {
        if (!this.issue.value) {
          throw new Error('手机号不能为空')
        }
        this.issue.check(this.question.required)
        this.codePopup = true
      } catch (e) {
        Message({ message: e.message, type: 'warning' })
      }
    },
    sendAgain() {
      MessageBox.alert('您确定要重新验证吗', {
        title: '重新验证'
      }).then(() => {
        let phone = this.issue.value
        this.oldPhone = phone
        this.issue.isValidateCode = false
        this.issue.value = ''
        this.msgFlag = false
        this.msgCode = ''
        this.clearCountDown()
      })
    }
  },
  created() {
    if(this.question.setHook) {
      // fix 有可能是 矩阵题嵌入的组件 question 与正常的不一致
      this.question.setHook('confirm',isOK=>{
        if(isOK) return
        this.$refs.input.$refs.reference.focus()
      })
    }
  },
  beforeDestroy() {
    this.clearCountDown()
  }
}
</script>
